import React, { useEffect, useState } from "react";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { Col, Row } from "react-bootstrap";
import ChecklistTemplateImage from "../../assets/icons/TemplateBuilder/checklist.svg";
import templateiconQuote from "../../assets/icons/TemplateBuilder/template-icon-quote.svg";
import templateiconInvoice from "../../assets/icons/TemplateBuilder/template-icon-invoice.svg";
import templateiconStock from "../../assets/icons/TemplateBuilder/template-icon-stock.svg";
import templateiconEmail from "../../assets/icons/TemplateBuilder/template-icon-email.svg";
import HiringWorkerImage from "../../assets/icons/TemplateBuilder/hiringworker.svg";
import "../../assets/styles/local/TemplateBuilder.css";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { Button, Dropdown, Menu, Tabs } from "antd";
import { templateTypes, availableTemplates } from "../../redux/actions/action";
// import TemplatesList from "../../components/TemplateBuilder/TemplatesList";
import TemplateTableList from "../../components/TemplateBuilder/TemplateTableList";
import { useSelector, useDispatch } from "react-redux";

const ensureArray = (value) => (Array.isArray(value) ? value : []);

const TemplatesList = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { TabPane } = Tabs;
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Template-Builder-List").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const typesOfTemplates = useSelector((data) => data.user.templateTypes);
  const availalableTemplateList = useSelector(
    (data) => data.user.availableTemplates,
  );

  const [showTemplates, setShowTemplates] = useState("allTemplates");
  const [activeTab, setActiveTab] = useState("");
  const [formsTemplateList, setFormsTemplateList] = useState([]);
  const [stocksTemplateList, setStocksTemplateList] = useState([]);
  const [invoiceTemplateList, setInvoiceTemplateList] = useState([]);
  const [quotesTemplateList, setQuotesTemplateList] = useState([]);
  const [emailTemplateList, setEmailTemplateList] = useState([]);
  const [checklistTemplateList, setChecklistTemplateList] = useState([]);
  const [othersTemplateList, setOthersTemplateList] = useState([]);

  useEffect(() => {
    dispatch(templateTypes());
    dispatch(availableTemplates());
  }, []);

  useEffect(() => {
    if (availalableTemplateList && availalableTemplateList.status) {
      let data = availalableTemplateList.data;
      console.log("data", data);
      setFormsTemplateList(ensureArray(data?.forms));
      setStocksTemplateList(ensureArray(data?.stocks));
      setInvoiceTemplateList(ensureArray(data?.invoices));
      setQuotesTemplateList(ensureArray(data?.quotes));
      setEmailTemplateList(ensureArray(data?.emails));
      setChecklistTemplateList(ensureArray(data?.checklists));
      setOthersTemplateList(ensureArray(data?.others));
    }
  }, [availalableTemplateList]);

  const handleRefresh = () => {
    dispatch(availableTemplates());
  };

  const totalTemplates =
    invoiceTemplateList.length +
    stocksTemplateList.length +
    quotesTemplateList.length +
    emailTemplateList.length +
    checklistTemplateList.length +
    othersTemplateList.length;

  return (
    <>
      <div className="row">
        <div className="col-xl-3">
          <div
            className="pt-4 pb-1 ps-2"
            style={{ borderBottom: "1px solid lightgrey", color: "grey" }}
          >
            {t("Template Categories")}
          </div>

          <div className="pt-2 ps-2">
            <ul className="p-0" style={{ listStyleType: "none" }}>
              <li
                className="pt-1 pb-1 cursor-pointer"
                style={{
                  fontWeight: showTemplates === "allTemplates" && "bold",
                }}
                onClick={() => {
                  setShowTemplates("allTemplates");
                }}
              >
                {/* All templates (10) */}
                {t("All templates ")}({totalTemplates})
              </li>

              <li
                className="pt-1 pb-1 cursor-pointer"
                style={{
                  fontWeight: showTemplates === "invoice" && "bold",
                }}
                onClick={() => {
                  setShowTemplates("invoice");
                  setActiveTab("invoice");
                }}
              >
                {/* Invoice (1) */}
                {t("Invoice")} {`(${invoiceTemplateList.length})`}
              </li>

              <li
                className="pt-1 pb-1 cursor-pointer"
                style={{
                  fontWeight: showTemplates === "stocks" && "bold",
                }}
                onClick={() => {
                  setShowTemplates("stocks");
                  setActiveTab("stocks");
                }}
              >
                {t("Stock")} {`(${stocksTemplateList.length})`}
              </li>

              <li
                className="pt-1 pb-1 cursor-pointer"
                style={{
                  fontWeight: showTemplates === "quotes" && "bold",
                }}
                onClick={() => {
                  setShowTemplates("quotes");
                  setActiveTab("quotes");
                }}
              >
                {/* Quotes (2) */}
                {t("Quotes")} {`(${quotesTemplateList.length})`}
              </li>

              <li
                className="pt-1 pb-1 cursor-pointer"
                style={{
                  fontWeight: showTemplates === "emails" && "bold",
                }}
                onClick={() => {
                  setShowTemplates("emails");
                  setActiveTab("emails");
                }}
              >
                {t("Emails ")} {`(${emailTemplateList.length})`}
              </li>

              <li
                className="pt-1 pb-1 cursor-pointer"
                style={{
                  fontWeight: showTemplates === "checklist" && "bold",
                }}
                onClick={() => {
                  setShowTemplates("checklist");
                  setActiveTab("checklist");
                }}
              >
                {/* Checklist (1) */}
                {t("Checklist")} {`(${checklistTemplateList.length})`}
              </li>

              <li
                className="pt-1 pb-1 cursor-pointer"
                style={{
                  fontWeight: showTemplates === "others" && "bold",
                }}
                onClick={() => {
                  setShowTemplates("others");
                  setActiveTab("others");
                }}
              >
                {/* Others (1) */}
                {t("Others")} {`(${othersTemplateList.length})`}
              </li>
            </ul>
          </div>
        </div>

        <div
          className="col"
          style={{ height: "auto", maxHeight: "450px", overflow: "auto" }}
        >
          {showTemplates === "allTemplates" && (
            <div className="d-flex flex-wrap ps-2 ps-lg-5">
              <div className="p-5 pb-0">
                <div
                  className="templates-custom pointer"
                  onClick={() => {
                    setShowTemplates("invoice");
                    setActiveTab("invoice");
                  }}
                >
                  <div className="template-img-section">
                    <img
                      src={templateiconInvoice}
                      className="template-img"
                      alt="Add Icon"
                    />
                  </div>
                  <div className="p-2 ps-5 hiring_worker_list">
                    <strong>
                      {t("Invoice")} {`(${invoiceTemplateList.length})`}
                    </strong>
                  </div>
                </div>
              </div>

              <div className="p-5 pb-0">
                <div
                  className="templates-custom pointer"
                  onClick={() => {
                    setShowTemplates("stocks");
                    setActiveTab("stocks");
                  }}
                >
                  <div className="template-img-section">
                    <img
                      src={templateiconStock}
                      className="template-img"
                      alt="Add Icon"
                    />
                  </div>
                  <div className="p-2 ps-5 hiring_worker_list">
                    <strong>
                      {t("Stock")} {`(${stocksTemplateList.length})`}
                    </strong>
                  </div>
                </div>
              </div>

              <div className="p-5 pb-0">
                <div
                  className="templates-custom pointer"
                  onClick={() => {
                    setShowTemplates("quotes");
                    setActiveTab("quotes");
                  }}
                >
                  <div className="template-img-section">
                    <img
                      src={templateiconQuote}
                      className="template-img"
                      alt="Add Icon"
                    />
                  </div>
                  <div className="p-2 ps-5 hiring_worker_list">
                    <strong>
                      {t("Quotes")} {`(${quotesTemplateList.length})`}
                    </strong>
                  </div>
                </div>
              </div>

              <div className="p-5 pb-0">
                <div
                  className="templates-custom pointer"
                  onClick={() => {
                    setShowTemplates("emails");
                    setActiveTab("emails");
                  }}
                >
                  <div className="template-img-section">
                    <img
                      src={templateiconEmail}
                      className="template-img"
                      alt="Add Icon"
                    />
                  </div>
                  <div className="p-2 ps-5 hiring_worker_list">
                    <strong>
                      {t("Emails ")} {`(${emailTemplateList.length})`}
                    </strong>
                  </div>
                </div>
              </div>

              <div className="p-5 pb-0">
                <div
                  className="templates-custom pointer"
                  onClick={() => {
                    setShowTemplates("checklist");
                    setActiveTab("checklist");
                  }}
                >
                  <div className="template-img-section">
                    <img
                      src={ChecklistTemplateImage}
                      className="template-img"
                      alt="Add Icon"
                    />
                  </div>
                  <div className="p-2 ps-5 check_list_txt">
                    <strong>
                      {/* Checklist */}
                      {t("Checklist")} {`(${checklistTemplateList.length})`}
                    </strong>
                  </div>
                </div>
              </div>

              <div className="p-5 pb-0">
                <div
                  className="templates-custom pointer"
                  onClick={() => {
                    setShowTemplates("others");
                    setActiveTab("others");
                  }}
                >
                  <div className="template-img-section">
                    <img
                      src={ChecklistTemplateImage}
                      className="template-img"
                      alt="Add Icon"
                    />
                  </div>
                  <div className="p-2 ps-5 hiring_worker_list">
                    <strong>
                      {t("Others")} {`(${othersTemplateList.length})`}
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* {showTemplates === "checklist" && (
          <div className="col">
            <div id="ascTemplate">
              <Tabs
                activeKey={activeTab}
                style={{ width: "100%" }}
                onTabClick={(key) => {
                  setActiveTab(key);
                }}
                className="templates-tab gap-2"
              >
                <TabPane
                  tab="checklist"
                  // tab={FetchTranslationList[31]?.translation}
                  key="checklist"
                  className="min-height-60 p-3"
                >
                  <TemplateTableList
                    data={checklistTemplateList}
                    editRoute="/checklist-builder/"
                    refreshData={handleRefresh}
                    header="Checklist"
                    // header={FetchTranslationList[38]?.translation}
                  />
                </TabPane>
              </Tabs>
            </div>
          </div>
        )} */}

          {showTemplates === "invoice" && (
            <div className="col">
              <div className="min-height-60 p-3 pt-4">
                <TemplateTableList
                  data={invoiceTemplateList}
                  editRoute="/invoice-builder/"
                  refreshData={handleRefresh}
                  header="Invoice"
                  // header={FetchTranslationList[38]?.translation}
                />
              </div>
            </div>
          )}

          {showTemplates === "stocks" && (
            <div className="col">
              <div className="min-height-60 p-3 pt-4">
                <TemplateTableList
                  data={stocksTemplateList}
                  editRoute="/stocks-builder/"
                  refreshData={handleRefresh}
                  header="Stocks"
                  // header={FetchTranslationList[38]?.translation}
                />
              </div>
            </div>
          )}

          {showTemplates === "quotes" && (
            <div className="col">
              <div className="min-height-60 p-3 pt-4">
                <TemplateTableList
                  data={quotesTemplateList}
                  editRoute="/quote-builder/"
                  refreshData={handleRefresh}
                  header="Quotes"
                  // header={FetchTranslationList[38]?.translation}
                />
              </div>
            </div>
          )}

          {showTemplates === "emails" && (
            <div className="col">
              <div className="min-height-60 p-3 pt-4">
                <TemplateTableList
                  data={emailTemplateList}
                  editRoute="/email-builder/"
                  refreshData={handleRefresh}
                  header="Emails"
                  // header={FetchTranslationList[38]?.translation}
                />
              </div>
            </div>
          )}

          {showTemplates === "checklist" && (
            <div className="col">
              <div className="min-height-60 p-3 pt-4">
                <TemplateTableList
                  data={checklistTemplateList}
                  editRoute="/checklist-builder/"
                  refreshData={handleRefresh}
                  header="Checklist"
                  // header={FetchTranslationList[38]?.translation}
                />
              </div>
            </div>
          )}

          {showTemplates === "others" && (
            <div className="col">
              <div className="min-height-60 p-3 pt-4">
                <TemplateTableList
                  data={othersTemplateList}
                  editRoute="/others-builder/"
                  refreshData={handleRefresh}
                  header="Others"
                  // header={FetchTranslationList[38]?.translation}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TemplatesList;
